module.exports = __webpack_public_path__ + "img/0Q3B3739_Black_MockedUp.69c0f2ce.jpg";